export class ProductClass {
  id: number = -1;

  name: string = '';
  code: string = '';
  description: string = '';

  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
